<template>
  <div class="index">  
    <HeaderPage :msgList="msgList" :userMsg="userMsg"></HeaderPage>
    <!-- <professional class="pro"></professional> -->
    <div class="content">
      <div class="left">
        <el-menu
          active-text-color="#fff"
          background-color="#fff"
          class="el-menu-vertical-demo"
          :default-openeds='openeds'
          text-color="#4b4c4d"
          unique-opened
          @open="handleOpen"
          @close="handleClose"
          :default-active="currentActive"
          router
          @select="handleSelect"
        >
          <el-sub-menu index="1">
            <template #title>
              <span style="font-weight: bold; font-size: 15px;"><el-icon><Monitor /></el-icon>工作台</span>
            </template>
            <el-menu-item index="/project">项目管理</el-menu-item>
            <el-menu-item index="/material">素材管理</el-menu-item>
            <el-menu-item index="/recycleBinPro">项目回收站管理</el-menu-item>
            <el-menu-item index="/recycleBinMat">素材回收站管理</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="2">
            <template #title>
              <span style="font-weight: bold; font-size: 15px;"><el-icon><CreditCard /></el-icon>我的账户</span>
            </template>
            <el-menu-item index="/user">账号管理</el-menu-item>
            <el-menu-item index="/order">订单管理</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="3">
            <template #title>
              <span style="font-weight: bold; font-size: 15px;"><el-icon><User /></el-icon>销售人员管理</span>
            </template>
            <el-menu-item index="/cust">销售人员列表</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="4">
            <template #title>
              <span style="font-weight: bold; font-size: 15px;"><img class="help_icon" src="@/assets/image/help.png">帮助</span>
            </template>
            <el-menu-item index="" @click="onClick">使用说明</el-menu-item>
            <el-menu-item index="">技术支持</el-menu-item>
          </el-sub-menu>
        </el-menu>

        
        <div class="capacityBox"><Capacity/></div>
        

      </div>
      <div class="right">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>
<style lang="scss">
@import "@/assets/css/icon.css";
@import '@/assets/css/index/index.scss';
</style>
<script>
import { inject } from "vue";
import { Monitor, CreditCard, QuestionFilled, User } from '@element-plus/icons-vue';
import professional from '@/components/Professional.vue';
import Capacity from '@/components/capacity/capacity.vue';
import HeaderPage from '@/components/headerPage/index.vue';
import { getNoReadMessageAPI,getuserinfo } from '@/api/api';
export default {
  components:{
    professional, Monitor, CreditCard, QuestionFilled, User, Capacity, HeaderPage,
  },
  data(){
    return{
      show:'project_status',
      currentActive: '/project',
      msgList: [],
      userMsg: null,
      userInfo: inject('user_data'),
    }
  },
  methods:{
    open(e){
      this.show=e;
    },
    /** 获取未读信息 */
    getOnMsgFun(){
      this.noReadMsgList = [];
      getNoReadMessageAPI().then((res)=>{
        this.msgList = res.data.list;
      })
    },
    /** 获取用户信息 */
    getuserinfoFun(){
      getuserinfo().then((res)=>{
        this.userMsg = res.data;
        this.userInfo.info = res.data;
        console.log(this.userInfo)
      })
    },

    /** 使用说明 */
    onClick(){
      let routeUrl =this.$router.resolve({path: '/instruct'})
      window.open(routeUrl.href, '_blank');
    }
  },
  created(){
    /** 获取当前router赋值给菜单 */
    this.currentActive = this.$route.path;
    this.getOnMsgFun();
    this.getuserinfoFun();
  },
};
</script>